module.exports = __webpack_public_path__ + "img/PimpernellaUndRobot.ffde3074.jpg";